<script setup lang="ts">
import type { ApiBlockGridArea, ElementItem } from "@edco/apollo";
import type { BlockGridLayout_Content } from "~/models/generated/BlockGridLayout_Content";
import BaseColumnLayout from "~/components/common/BaseColumnLayout.vue";

const props = defineProps<{
  content: ElementItem<BlockGridLayout_Content>,
  areas: ApiBlockGridArea[],
  settings?: ElementItem
}>();
</script>

<template>
  <div>
  <BaseColumnLayout
    :areas="areas"
    :theme="settings?.properties.blockTheme"
    :no-top-padding="settings?.properties.noTopPadding"
    :no-bottom-padding="settings?.properties.noBottomPadding"
    layout-class="content-column" /></div>
</template>
